import { Stack, Text } from '@mantine/core'

import type { MergePlan } from '../utils/merge-plan'

type Props = {
  plan: MergePlan
  message?: string | null
}

export const MergeDecisionSummary = ({ plan, message }: Props) => {
  const reason = plan.reason ?? message?.split(': ').slice(1).join(': ') ?? null

  return (
    <Stack gap={6}>
      {plan.targetContactId && (
        <Text size='sm'>
          <Text span fw={600}>
            Target (kept):{' '}
          </Text>
          {plan.targetContactId}
        </Text>
      )}
      {plan.mergeContactId && (
        <Text size='sm'>
          <Text span fw={600}>
            Merged into target:{' '}
          </Text>
          {plan.mergeContactId}
        </Text>
      )}
      {reason && (
        <Text size='sm'>
          <Text span fw={600}>
            Reason:{' '}
          </Text>
          {reason}
        </Text>
      )}
    </Stack>
  )
}
